import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './styles/animations.css';
import App from './App';

if (process.env.NODE_ENV === 'production') {
  ['debug', 'error', 'info', 'log', 'warn'].forEach((method) => {
    console[method] = () => {};
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
